import styles from "./styles.module.scss";

export interface IInfoItemProps {
  title: string;
  value: string | number;
  image: string;
}

export const InfoItem = (props: IInfoItemProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.image_wrapper}>
        <img alt="complex" src={props.image} />
      </div>
      <div className={styles.text_wrapper}>
        <p className={"hint2"}>{props.title}</p>
        <p className={"p1"}>{props.value}</p>
      </div>
    </div>
  );
};

export default InfoItem;
